import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import VisitForm from "../visits/VisitForm";

/** Resource for stop show (visit form). List/create handled via SlotPlanner / DailyOps. */
export default {
  show: VisitForm,
  icon: PersonPinCircleIcon,
  label: "Stops",
  options: { label: "Stops" },
  name: "houseVisitStops",
};
